import { browserTracingIntegration, extraErrorDataIntegration, init } from '@sentry/vue'
import type { App } from 'vue'

import router from '@/router'

export function createSentry(app: App<Element>) {
    init({
        app,
        dsn: 'https://a72d6782b816bc65a7611575a0434f21@sentry.it-team.cloud/173',
        tracePropagationTargets: ['localhost', 'localhost:5173'],
        integrations: [
            browserTracingIntegration({
                router
            }),
            extraErrorDataIntegration()
        ]
    })
}
